import UserColors from 'Editor/services/UserColors/UserColors';
import { hexToRgb } from 'assets/colors';
import './TemporaryComment.module.scss';
import { ELEMENTS } from 'Editor/services/consts';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';
import { CommentElement } from './CommentElement';

const ATTIBUTES = {
  AUTHOR: 'author',
  SELECTED: 'selected',
  DISABLED: 'disabled',
};

export class TemporaryCommentElement extends CommentElement {
  static get observedAttributes() {
    return [ATTIBUTES.AUTHOR, ATTIBUTES.SELECTED, ATTIBUTES.DISABLED];
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.preRendered) {
      this.preRender();
    }
  }

  preRender() {
    this.style.fontFamily = 'inherit';
    this.style.fontSize = 'inherit';
    this.style.fontStyle = 'inherit';
    this.style.fontWeight = 'inherit';
    this.style.textDecoration = 'inherit';
    this.style.textDecoration = 'inherit';
    this.style.verticalAlign = 'inherit';

    this.setBackground = this.setBackground.bind(this);

    this.setBackground();

    super.preRender();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (document.contains(this) && oldValue !== newValue) {
      if (name === ATTIBUTES.AUTHOR || name === ATTIBUTES.SELECTED) {
        this.setBackground();
      } else if (name === ATTIBUTES.DISABLED) {
        this._handleHiddenChange();
      }
    }
  }

  get hidden() {
    return this.getAttribute('disabled') === 'true';
  }

  get selected() {
    return this.hasAttribute('selected');
  }

  set selected(val) {
    if (val) {
      this.setAttribute('selected', 'true');
    } else {
      this.removeAttribute('selected');
    }
  }

  get elementReference() {
    return this.getAttribute('element_reference');
  }

  selectElement() {
    if (!this.hidden) {
      this.selected = true;
    }
  }

  deselectElement() {
    this.selected = false;
  }

  _handleHiddenChange() {
    if (this.hidden) {
      this.clearBackground();
    } else {
      this.setUserColor();
    }
  }

  setHidden(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
  }

  getAuthor() {
    return this.getAttribute('author') || this.getAttribute('user');
  }

  reRenderBackground() {
    this.setBackground();
  }

  setBackground() {
    if (this.setBackgroundTimeout) {
      clearTimeout(this.setBackgroundTimeout);
    }

    this.setBackgroundTimeout = setTimeout(() => {
      if (!this.hidden) {
        const bounds = this.getClientRects();
        const lineHeight = parseInt(window.getComputedStyle(this).lineHeight, 10);
        if (bounds.length === 0) {
          return;
        }
        const boxShadowLength = (lineHeight - bounds[0].height) / 2;
        let color;
        const author = this.getAuthor();
        if (author) {
          const colors = UserColors.getUserColor(author);
          const selectedColor = colors?.tint30;
          const isSelected =
            this.hasAttribute('selected') && this.getAttribute('selected') === 'true';
          if (colors?.base) {
            const rgbObject = hexToRgb(colors?.base);
            if (rgbObject != null) {
              if (this.hasAttribute('selected') && this.getAttribute('selected') === 'true') {
                color = selectedColor;
              } else {
                color = `rgba( ${rgbObject[0]}, ${rgbObject[1]}, ${rgbObject[2]}, 0.14)`;
              }
            } else {
              color = colors?.base;
            }
            const zoomValue = ReduxInterface.getZoomValue();
            const height = bounds[0].height / zoomValue;
            this.style.boxShadow = `inset 0px -${Math.min(height, lineHeight)}px 0px ${color} ${
              boxShadowLength >= 0
                ? `, 0px ${Math.min(boxShadowLength, 5)}px 0px ${color}, 0px -${Math.min(
                    boxShadowLength,
                    5,
                  )}px 0px 0px ${color}`
                : ''
            } ${isSelected ? ', 0px 8px 8px rgba(0, 0, 0, 0.25)' : ''}`;
          }
        }
      }
    }, 50);
  }

  clearBackground() {
    this.style.boxShadow = 'none';
  }

  isEqual(node: HTMLElement) {
    return (
      this.tagName === node.tagName &&
      this.getAttribute('element_reference') === node.getAttribute('element_reference')
    );
  }
}

if (!window.customElements.get(ELEMENTS.TemporaryComment.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.TemporaryComment.IDENTIFIER, TemporaryCommentElement);
}
